export const DEFAULT_TAGS_FILTER_MESSAGE = "You can filter tags by typing in keys or values. To add more tag filters, just press the 'Add more' button. This will function with an AND operation.";
